import React from 'react';
import styled from '@emotion/styled';

// Generates the "background mode" (full-width hero image) button overrides.
// The colors follow the banner's text color so that:
//  - gradient overlay (white text) -> light/white button theme
//  - no overlay (dark text #2B2B2A) -> dark/black button theme
const backgroundModeStyles = (props) => {
	if (!props.isBackgroundMode) return '';
	const themeColor = props.bannerTextColor || '#ffffff';
	const isLightTheme = themeColor === '#ffffff';
	const selectedTextColor = isLightTheme ? '#2B2B2A' : '#ffffff';
	return `
		border-color: ${themeColor};
		background: ${props.selected ? themeColor : 'transparent'};
		color: ${props.selected ? selectedTextColor : themeColor};
	`;
};

// Styled Button
const StyledButton = styled.button`
	background: ${(props) => (props.selected ? '#000' : 'transparent')};
	color: ${(props) => (props.selected ? '#fff' : '#2B2A2F')};
	cursor: pointer;
	font-size: 14px;
	text-transform: uppercase;
	padding: 12px 24px;
	border: 1px solid #2b2a2f;
	border-radius: 4px;
	transition: background 0.3s, color 0.3s;
	width: 140px;
	height: 44px;
	letter-spacing: -0.48px;
	font-weight: 400 !important;
	line-height: 130%;
	text-align: center;

	${(props) => backgroundModeStyles(props)}

	.wsj & {
		font-family: arial, sans-serif !important;
	}
	.fox & {
		background: ${(props) => (props.selected ? '#D4DDF0' : 'transparent')};
		color: ${(props) => (props.selected ? '#222' : '#2B2A2F')};
		width: 212px;
		font-family: Roboto;
		font-size: 14px;
		font-style: normal;
		font-weight: 600 !important;
		line-height: 16px; /* 114.286% */
		letter-spacing: 0.42px;
		text-transform: uppercase;
		${(props) => backgroundModeStyles(props)}
	}

	.bon & {
		font-family: 'FuturaPT', sans-serif;
		font-weight: 500 !important;
		background: ${(props) => (props.selected ? '#000' : 'transparent')};
		color: ${(props) => (props.selected ? '#fff' : '#000')};
		width: 100px;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 22px;
		letter-spacing: 0.48px;
		text-transform: uppercase;
		border-radius: 0px;
		${(props) => backgroundModeStyles(props)}
	}
	.law & {
		font-family: 'Roboto';
		font-weight: 600 !important;
		background: ${(props) => (props.selected ? '#222222' : 'transparent')};
		color: ${(props) => (props.selected ? '#FFFFFF' : '#2B2A2F')};
		${(props) => backgroundModeStyles(props)}
	}
	.osw & {
		font-family: 'Roboto' !important;
		font-weight: 700 !important;
		border-radius: 24px;
		background: ${(props) => (props.selected ? '#222222' : 'transparent')};
		color: ${(props) => (props.selected ? '#FFFFFF' : '#2B2A2F')};
		${(props) => backgroundModeStyles(props)}
	}
	.npr & {
		font-family: 'Roboto';
		font-weight: 600 !important;
		background: ${(props) => (props.selected ? '#222222' : 'transparent')};
		color: ${(props) => (props.selected ? '#FFFFFF' : '#2B2A2F')};
		${(props) => backgroundModeStyles(props)}
	}
`;

// SelectorButton Component
const SelectorButton = ({
	product,
	customTitle,
	selected,
	onClick,
	isBackgroundMode,
	bannerTextColor,
}) => {
	return (
		<StyledButton
			selected={selected}
			onClick={onClick} // Call onClick directly
			aria-selected={selected}
			isBackgroundMode={isBackgroundMode}
			bannerTextColor={bannerTextColor}
		>
			{customTitle || product?.name || 'Unknown Product'}{' '}
			{/* Use customTitle if available */}
		</StyledButton>
	);
};

export default SelectorButton;
